// extracted by mini-css-extract-plugin
module.exports = {"mobileOnly":"ResponsiveUIUtils_mobileOnly__1tQCt","desktopOnly":"ResponsiveUIUtils_desktopOnly__2Fw6J","disableSmallScreens":"ResponsiveUIUtils_disableSmallScreens__1rorn"};